import {Component, ViewEncapsulation, ViewChild, Input, OnChanges, SimpleChanges} from '@angular/core';
import { extend } from '@syncfusion/ej2-base';
import {
    TimeScaleModel,
    GroupModel,
    EventSettingsModel,
    PopupOpenEventArgs,
    RenderCellEventArgs
} from '@syncfusion/ej2-angular-schedule';
import { ScheduleComponent, EventRenderedArgs, View } from '@syncfusion/ej2-angular-schedule';
import { timelineResourceData } from './syncfusion-sample.datasource';
import {StringUtils} from '../../../shared/utils';
@Component({
    selector: 'syncfusion-scheduler-basic-view',
    templateUrl: 'basic-view.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None,

})

export class BasicViewComponent implements OnChanges {
    @ViewChild('scheduleObj')
    public scheduleObj: ScheduleComponent;

    @Input()
    public showHeaderBar = true;
    @Input()
    public schdChartData = [];
    //public selectedDate: Date = new Date(2018, 11, 1);
    public selectedDate: Date = new Date();
    timelineResourceData = [];

    public eventSettings: EventSettingsModel = { dataSource: <Object[]>extend([], this.timelineResourceData, null, true) };
    public scheduleView: View = 'Week';
    public datas: string[] = ['Day', 'Week', 'WorkWeek', 'Month'];

    ngOnChanges(changes: SimpleChanges): void {
        const chng = changes['schdChartData'];
        if (chng !== undefined && this.schdChartData !== undefined) {
            this.getSchdChartData();

            this.eventSettings = {
                dataSource: <Object[]>extend([], this.timelineResourceData, null, true)
            };
        }
    }

    getSchdChartData() {
        this.timelineResourceData = [];
        this.schdChartData.forEach((_layers: any, lyIdx) => {
            const layerCnt = lyIdx + 1;
            _layers.schdChartOnCallList.forEach((_blocks: any) => {
                _blocks.schdChartOnCallBlkList.forEach((_block) => {
                    const timelineObject = {
                        Id: 1,
                        Subject: 'name',
                        StartTime: new Date(2019, 0, 1, 0, 0),
                        EndTime: new Date(2019, 0, 14, 0, 0),
                        IsAllDay: false,
                        LayerId: 1,
                        CategoryColor: '#cb6bb2'
                    };
                    timelineObject.Id = _block.unqKey;
                    timelineObject.Subject = _blocks.mappTrgtDispNm;
                    timelineObject.StartTime = StringUtils.getDate(_block.onCallStDt);
                    timelineObject.EndTime = StringUtils.getDate(_block.onCallEdDt);
                    timelineObject.LayerId = layerCnt;

                    this.timelineResourceData.push(timelineObject);
                });
            });
        });
    }

    onEventRendered(args: EventRenderedArgs): void {
        const categoryColor: string = args.data.CategoryColor as string;
        if (!args.element || !categoryColor) {
            return;
        }
        if (this.scheduleObj.currentView === 'Agenda') {
            (args.element.firstChild as HTMLElement).style.borderLeftColor = categoryColor;
        } else {
            args.element.style.backgroundColor = categoryColor;
        }
    }

    onEventClick(): void {
        console.log('Schedule Event Click event called');
        //this.scheduleObj.openEditor('', 'Add');
    }
    onPopupOpen(args: PopupOpenEventArgs): void {
        // 스케쥴 팝업수정

        // 색을 넣을수 있는 header부분에 들어가있는
        const $elem = args.element.querySelectorAll('.e-popup-header')[0];
        // 사용자 이름과
        const $subject = args.element.querySelectorAll('.e-subject-wrap')[0];
        // 수정버튼을
        const $button = args.element.querySelectorAll('.e-header-icon-wrapper')[0];
        // 팝업 콘텐츠 안에 집어넣고
        const $content = args.element.querySelectorAll('.e-popup-content')[0];
        // 그 수정버튼은 create override로 명시한다
        const buttonTxt = document.createTextNode('Create Override');

        // 커스텀 팝업이 아닌 기존 syncfusion팝업에 있는 클래스가 있다면
        if ($elem) {
          // 사용자 이름을 팝업 콘텐츠 맨 처음에 집어넣고
          $content.insertBefore($subject, $content.childNodes[0]);
          // 수정 버튼을 콘텐츠에 삽입한다.
          $content.appendChild($button);
          // 수정 버튼에 create override 텍스트를 넣어준다.
          $button.childNodes[0].appendChild(buttonTxt);
        }

        console.log('Schedule Popup Open event called');
    }

    onRenderCell(args: RenderCellEventArgs): void {
        //과거일자 백그라운드
        if (args.element.classList.contains('e-work-cells') && this.selectedDate > args.date) {
            args.element.classList.add('past');
            //args.element['style'].background = '#deecfc';
        }
        /*if (args.element.classList.contains('e-work-hours') && (args.date.getDate() === 12 || args.date.getDate() === 14)) {
            args.element['style'].background = '#deecfc';
        }*/
    }
}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/scheduler/basic-view.component.ts